/**
 * Firebase initialization and service exports.
 *
 * Configures the Firebase app with project credentials and exports shared
 * instances of Analytics, Realtime Database, Auth, and Google Auth Provider
 * for use throughout the application.
 */
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBA-WbwDT1UUBRE3IZmrZUKEX8sGYa4JdQ",
  authDomain: "do-i-need-sunscreen.firebaseapp.com",
  databaseURL: "https://do-i-need-sunscreen-default-rtdb.firebaseio.com",
  projectId: "do-i-need-sunscreen",
  storageBucket: "do-i-need-sunscreen.firebasestorage.app",
  messagingSenderId: "123596029282",
  appId: "1:123596029282:web:4e7eede2e950afb321403b",
  measurementId: "G-G909D0GBHG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const analytics = getAnalytics(app);
export const database = getDatabase(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

export default app;